import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { getBreakpointMinWidth } from "@/styles/utils/Utils";
import { breakpoints, colors } from "@/styles/utils/vars";
import { ButtonBase, ButtonSliderArrow } from "@/ui/Button/StyledButton";
import { cssDialogBackdrop } from "@/ui/Modal";
import { cssNavNext, cssNavPrev } from "../../../../Swiper/StyledSwiper";
export const cssMediaModal = "cssMediaModal_c18p9vqu";
export const cssEnlargeImageContainer = "cssEnlargeImageContainer_c1rul038";
export const cssEnlargedImage = "cssEnlargedImage_cofci2r";
export const StyledGalleryItem = /*#__PURE__*/styled('div')({
  name: "StyledGalleryItem",
  class: "StyledGalleryItem_s1gi3iuj"
});
export const cssSliderThumbs = "cssSliderThumbs_c1cgjuuk";
export const cssSliderImage = "cssSliderImage_c1p8ylk";
export const StyledThumb = /*#__PURE__*/styled('div')({
  name: "StyledThumb",
  class: "StyledThumb_s1cusxg9"
});
export const StyledGallerySlider = /*#__PURE__*/styled('div')({
  name: "StyledGallerySlider",
  class: "StyledGallerySlider_s1u2rn8y"
});

require("./StyledGallery.linaria.module.css!=!../../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledGallery.tsx");